module.exports = __webpack_public_path__ + "static/img/1-6.f7d3594.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/1-6.png
// module id = kz9Q
// module chunks = 15